import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, ResponseResult } from 'vnpost-shared';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(
      http,
      injector,
      `${environment.apiDomain.llbJavaEndpoint}/report`
    );
  }

  sumByParams(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/searchTotal`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  getDataReport(model: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/search`;
    return this._http
      .post<any>(apiUrl, model)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
  // exportExcel(model: any): Promise<any> {
  //   const apiUrl = `${this.serviceUri}/export`;
  //   return this._http
  //     .post<any>(apiUrl, model)
  //     .pipe(catchError((err) => this.handleError(err, this._injector)))
  //     .toPromise();
  // }
  exportExcel(model: any): Observable<Blob> {
    const apiUrl = `${this.serviceUri}/export`;
    return this._http.post(apiUrl, model, { responseType: 'blob' });
  }

}
